import { useCallback, useEffect, useMemo} from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { AppBarTitle } from '@components/app-bar-title';
import { useSnackbar } from 'notistack';
import { IconButton, AppBar, Typography, Button, Grid } from '@material-ui/core';
import * as contentService from '@api/content';
import * as holdingDataService from '@api/holding-data';
import { finalize } from 'rxjs/operators';
import { ContentForm } from './form/content.form';
import styled from 'styled-components';
import { usePintMaster, windowObj } from '@lib/common';
import { useDefaultImage } from '@lib/common';
import { Skeleton } from '@material-ui/lab';

import MovieFilterTwoToneIcon from '@material-ui/icons/MovieFilterTwoTone';
import { grey } from '@material-ui/core/colors';
import { useRequest } from '@lib/common';
import SpellcheckRoundedIcon from '@material-ui/icons/SpellcheckRounded';
import { PageLoading } from '@components/page-loading';
import { FadeInContainer } from '@components/fadein-container';
import { useGvdSSourceDataLoader } from 'services/gvd-dataloader.service';
import { ContentType } from '@lib/content';
const getMatchedMasters = (
  values: string | null | undefined,
  masters: any[] = []
) => {
  if (!values || !masters.length) {
    return [];
  }

  return values
    .split(",")
    .map(v => v.trim())
    .map(value =>
      masters.find(
        m => m.name?.trim().toLowerCase() === value.toLowerCase()
      )
    )
    .filter(Boolean);
};

const getMatchedMaster = (
  value: string | null | undefined,
  masters: any[] = []
) => {
  if (!value || !masters.length) {
    return null;
  }

  return (
    masters.find(
      m => m.name?.trim().toLowerCase() === value.trim().toLowerCase()
    ) ?? null
  );
};

export const NewContent = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const history = useHistory();
  const { master: masterGenres } = usePintMaster('genres');
  const { master: masterLanguages } = usePintMaster('languages');
    const { master: masterCountries } = usePintMaster('countries');

 
  useEffect(()=>{
   //  console.log('master', masterGenres, masterLanguages,masterCountries);
  },[masterGenres, masterLanguages,masterCountries])
  
  const prefillData = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const key = params.get('prefillKey');
    if (!key) return null;

    const stored = localStorage.getItem(key);
    if (!stored) return null;

    const parsed = JSON.parse(stored);
    // Convert "Movie" -> 0, "Series" -> 1, etc.
    const contentType =
      ContentType[
        parsed.content_type?.toUpperCase().replace(/\s+/g, '') as keyof typeof ContentType
      ];
const mappedGenres = getMatchedMasters(parsed.genres, masterGenres);

const mappedLanguage = getMatchedMaster(
  parsed.lang_names,
  masterLanguages
);

const mappedCountries = getMatchedMasters(
  parsed.origin_country_name,
  masterCountries
);

return {
  ...parsed,
  content_type: contentType,

  // 👇 These are what the form expects
  genres_id: mappedGenres,
  language_id: mappedLanguage,
  origin_country: mappedCountries,
};
  }, [location.search, masterGenres, masterLanguages, masterCountries]);


  const redirectToSearch = useCallback(() => {
    if (history.location.search) {
      const returnTo = new URLSearchParams(history.location.search).get('returnTo');
      if (returnTo) {
        history.push(returnTo);
        return;
      }
    }
    history.push(`/content/search`);
  }, [history]);

  // Form Actions
  const createContent = useCallback(content => {
    const infoNotification = enqueueSnackbar('Please wait creating new content', {
      variant: 'info',
    });
    delete content.vtr_id;
    return contentService
      .create(content)
      .pipe(finalize(() => closeSnackbar(infoNotification)))
      .subscribe({
        next: () => {
          enqueueSnackbar('New Content created Successfully!', { variant: 'success' });
          redirectToSearch();
        },
        error: err => {
          enqueueSnackbar(`Error creating new content (${err?.response?.data?.error})`, {
            variant: 'error',
          });
        },
        complete: () => closeSnackbar(infoNotification),
      });
  }, []);

  return (
    <div>
      <AppBarTitle>
        <IconButton onClick={null} color="inherit" edge="start">
          <MovieFilterTwoToneIcon />
        </IconButton>
        New Content
      </AppBarTitle>
      <ContentForm onFinish={createContent} defaultValues={prefillData as any }/>
    </div>
  );
};

const Paragraph = styled.p`
font-size: 1.1rem;
font-weight: 400;
line-height: 1.43;
margin:2px;
`

const Span = styled.span`
font-size: 13px;
font-weight: 400;
line-height: 1.43;
margin:2px;
`

export const ContentEdit = ({
  name: entityName,
  vtrId: entityVtrId,
  type: entityType,
  white = false,
  avatarImg = null,
  contentData = null,
}: {
  name: React.ReactNode;
  vtrId?: string;
  type: string;
  white?: boolean;
  avatarImg?: string;
  contentData?: any;
}) => {
  const secondaryProps = useMemo(() => (white ? { color: 'inherit' } : {}), [white]);
  let Details: any;
  
  // if (entityType === EntityType.content) {
  //   Details = ShowCompanyDetails;
  // }
  const {title="",original_title="",content_type="",lang_names="",release_year="",origin_country_name=""} = contentData;
  const contentType = content_type == 0 ? 'Movie' : content_type == 2 ? 'Book' : content_type == 3 ? 'Podcast' : content_type == 4 ? 'Game' : content_type == 5 ? 'Format' :content_type == 6 ? 'Story': content_type == 7 ? 'IP' : content_type == 8 ? 'Micro-Series' : 'TV Series';
  return entityName || entityVtrId ? (
    <>
      <Paragraph>Title : {title || original_title}</Paragraph>
      <Span>Type : {contentType},</Span>
      <Span>Language : {lang_names},</Span>
      <Span>Release year : {release_year},</Span>
      <Span>Country of origin : {origin_country_name}</Span>
    </>
  ) : null;
};


const ContentData = ({ id, content, loading }) => {
  const srcList = useMemo(() => {
    return [`${windowObj.RAZZLE_S3_BUCKET_URL}/${id}.png`, '/images/company_default.svg'].filter(
      e => e
    );
  }, []);
  const { src: fallbackedSource } = useDefaultImage({
    srcList,
    defaultSrc: '/images/company_default.svg',
    useSuspense: false,
  });
  return content ? (
    <>
      <Grid item>
        <ContentEdit
          name={content.title || ''}
          vtrId={id}
          type="CONTENT"
          avatarImg={fallbackedSource}
          contentData={content}
        />
      </Grid>
    </>
  ) : (
    <Skeleton
      style={{ display: 'block' }}
      variant="rect"
      width={200}
      height={70}
      animation="wave"
    />
  );
};

export function EditContent() {
  const { id } = useParams<{ id: string }>();

  const { loading: contentLoading, result: content } = useRequest(
    () => contentService.get(id),
    [id]
  );

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const history = useHistory();
  const redirectToSearch = useCallback(() => {
    if (history.location.search) {
      const returnTo = new URLSearchParams(history.location.search).get('returnTo');
      if (returnTo) {
        history.push(returnTo);
        return;
      }
    }
    history.push(`/content/search`);
  }, [history]);
  // Form Actions
  const editContent = useCallback(
    udpContent => {
      const infoNotification = enqueueSnackbar('Please wait editing Content', { variant: 'info' });
      const updatedData = convertEmptyToNull(udpContent);
      return contentService
        .update(updatedData)
        .pipe(finalize(() => closeSnackbar(infoNotification)))
        .subscribe({
          next: () => {
            enqueueSnackbar('Content updated Successfully!', { variant: 'success' });
            redirectToSearch();
          },
          error: err =>
            enqueueSnackbar(`Error updating content (${err?.response?.data?.error})`, {
              variant: 'error',
            }),
        });
    },
    [enqueueSnackbar, history, id]
  );

  return (
    <div>
      <AppBarTitle>
      <Grid container spacing={3}>
        <Grid item style={{ alignSelf: 'center' }}>
          <IconButton onClick={null} color="inherit" edge="start">
            <SpellcheckRoundedIcon />
          </IconButton>
          Edit Content
        </Grid>
        <Grid item>
            <ContentDataStyle>
              <ContentData id={id} content={content} loading={contentLoading} />
            </ContentDataStyle>
          </Grid>
      </Grid>
      </AppBarTitle>
      {contentLoading && !content ? (
        <PageLoading>Loading Content to edit...</PageLoading>
      ) : (
        <FadeInContainer $anime=".5s">
          <ContentForm edit defaultValues={content as any} onFinish={editContent} />
        </FadeInContainer>
      )}
    </div>
  );
}

const ContentDataStyle = styled.div`
  .MuiTypography-colorTextSecondary {
    color: white;
  }
  .MuiListItemAvatar-root {
    display: none !important;
  }
  .MuiSvgIcon-colorPrimary {
    color: white;
  }
`;


export function CreateContent() {
  const { gnid } = useParams<{ gnid: string }>(); //useparams get the path params (deal id)
  
  const { loading, data: content, error } = useGvdSSourceDataLoader(gnid);
   
  if (content) {
    content['title'] = content?.title_en;
    content['lang_names'] = content?.language;
    content['cast_crew'] = content?.cast_role;
    content['content_type'] = content?.type == 'MOVIE' ? 0 : 1;
  }

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const history = useHistory();

  const redirectToSearch = useCallback(() => {
    if (history.location.search) {
      const returnTo = new URLSearchParams(history.location.search).get('returnTo');
      if (returnTo) {
        history.push(returnTo);
        return;
      }
    }
    history.push('/content/search');
  }, [history]);
 
  // Form Actions
  const createContent = useCallback(content => {
    const infoNotification = enqueueSnackbar('Please wait creating new content', {
      variant: 'info',
    });

    if(content){
      content['gnid'] = gnid
    }
  
    return contentService
      .create(content)
      .pipe(finalize(() => closeSnackbar(infoNotification)))
      .subscribe({
        next: () => {
          enqueueSnackbar('New Content created Successfully!', { variant: 'success' });
          redirectToSearch();
        },
        error: err => {
          enqueueSnackbar(`Error creating new content (${err?.response?.data?.error})`, {
            variant: 'error',
          });
        },
        complete: () => closeSnackbar(infoNotification),
      });
  }, []);

  return (
    <div>
      <AppBarTitle>
        <IconButton onClick={null} color="inherit" edge="start">
          <SpellcheckRoundedIcon />
        </IconButton>
        Create Content
      </AppBarTitle>
      {loading && !content ? (
        <PageLoading>Loading Content to create...</PageLoading>
      ) : (
        <FadeInContainer $anime=".5s">
          <ContentForm edit defaultValues={content as any} onFinish={createContent} />
        </FadeInContainer>
      )}
    </div>
  );
}
function convertEmptyToNull(obj: any): any {
  // ✅ Preserve Date objects
  if (obj instanceof Date) {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(item => convertEmptyToNull(item));
  }

  if (obj !== null && typeof obj === "object") {
    const newObj: any = {};
    Object.keys(obj).forEach(key => {
      const value = obj[key];
      // Rule 1: Convert empty strings to null
         if (key === "genres_id" && value === "") {
        newObj[key] = ""; // keep as empty string

      }else if (value === "") {
        newObj[key] = null;

     /*  // Rule 2: Convert popularity: 0 or 0.0 to null
      } else if (key === "popularity" && typeof value === "number" && value === 0) {
        newObj[key] = null; */
      }  else {
        newObj[key] = convertEmptyToNull(value);
      }
    });
    return newObj;
  }

  // Primitive values (string, number, boolean, null...)
  return obj === "" ? null : obj;
}